import type { HelpFile } from '../../types/help'
import { ScriptInboundConfigCardTestIds } from '../../../testids/ScriptInboundConfigCardTestIds'

export const scriptInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/script-connector',
  texts: {
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCard]:
      'Konfiguration eines eingehenden skriptbasierten Konnektors — legt fest, wie das System Identitäten und Konten vom Skript-Endpunkt abruft.',
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCardError]:
      'Die Konfiguration des eingehenden Skripts konnte nicht geladen werden; der Konnektor läuft erst nach Behebung des Fehlers.',
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCardLoading]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfig]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfigError]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfigLoading]: null,
    [ScriptInboundConfigCardTestIds.btnCreateScriptConfig]:
      'Initiale eingehende Konfiguration für diesen Skript-Konnektor erstellen.',
    [ScriptInboundConfigCardTestIds.btnEditScriptConfig]:
      'Eingehende Skript-Konfiguration bearbeiten; Änderungen gelten ab dem nächsten eingehenden Lauf.',
    [ScriptInboundConfigCardTestIds.btnValidateScript]:
      'Probelauf gegen den Skript-Endpunkt zur Konfigurationsprüfung — ohne Änderungen vorzunehmen.',
    [ScriptInboundConfigCardTestIds.inputScriptApiKeyHeader]:
      'HTTP-Headername, in dem der API-Schlüssel gesendet wird (z. B. X-API-Key).',
    [ScriptInboundConfigCardTestIds.inputScriptApiKeySecretRef]:
      'Referenz auf den Eintrag im Secret-Store, der den API-Schlüssel enthält.',
    [ScriptInboundConfigCardTestIds.inputScriptBaseUrl]:
      'Basis-URL des Skript-Endpunkts, den der Konnektor aufruft.',
    [ScriptInboundConfigCardTestIds.inputScriptClientSecretRef]:
      'Referenz auf das OAuth2-Client-Secret, das vom Skript-Konnektor verwendet wird.',
    [ScriptInboundConfigCardTestIds.inputScriptPasswordSecretRef]:
      'Referenz auf das Passwort-Secret, das vom Skript-Konnektor verwendet wird.',
    [ScriptInboundConfigCardTestIds.inputScriptConnectTimeout]:
      'Sekunden, die auf eine TCP-Verbindung zum Skript-Endpunkt gewartet wird, bevor abgebrochen wird.',
    [ScriptInboundConfigCardTestIds.inputScriptReadTimeout]:
      'Sekunden, die nach Verbindungsaufbau auf eine Antwort gewartet wird.',
    [ScriptInboundConfigCardTestIds.inputScriptTokenSecretRef]:
      'Referenz auf den Eintrag im Secret-Store, der den Bearer-Token enthält.',
    [ScriptInboundConfigCardTestIds.selectScriptAuthType]:
      'Authentifizierungsmechanismus beim Aufruf des Skript-Endpunkts (keine, API-Schlüssel oder Bearer-Token).',
  },
}
